<template>
    <div class="page" style="height: 100%;">
      <Header title="收货地址" :leftHandler="selectNewAddress" />
      <div class="receiving-address">
        <van-radio-group v-model="addressId" class="receiving-address-list" v-for="(address, index) in addressList" :key="index">
          <van-radio :name="address.addressId" @click="chooseValue(address)" >
          <div @click="selectNewAddress(address.addressId)">
            <div class="item margin-b-4">
              <span>{{ address.contactPerson }}</span>
              <span>{{ address.contactMobile }}</span>
            </div>
            <div class="item margin-b-4">{{address.provinceName}}{{address.cityName}}{{address.countyName}}{{ address.detailAddress }}</div>
          </div>
          <van-divider />
          <div class="item" :class="{ 'flex-end': !Boolean(address.isDefault) }">
            <van-checkbox :value="true" v-if="address.isDefault">默认地址</van-checkbox>
            <div class="item text-green">
              <div @click="receivingAddressRemove(address)">
                <van-icon :name="getBannerMobileImageUri('/img/delete-icon.png')"></van-icon>删除
              </div>
              <div @click="receivingAddressModify(address)">
                <van-icon :name="getBannerMobileImageUri('/img/edit-icon@2x.png')"></van-icon>编辑
              </div>
            </div>
          </div>
          </van-radio>
      </van-radio-group>
        <div class="text-center" >
          <van-button type="primary" class="center-personal-data-submit" @click="receivingAddressAdd">添加地址</van-button>
          <van-button type="primary" class="center-personal-data-submit" @click="grabAndGo">提交订单</van-button>
        </div>
        <!-- 删除弹出层 -->
        <van-popup v-model="popupOption.popupShow" class="popup" round>
          <div class="popup-title">
            <van-icon class="closeIcon" size="0.5rem" :name="getBannerMobileImageUri('/img/close-modal.png')"
              @click="closeModal"></van-icon>
            <p class="text-center">{{ popupOption.title }}</p>
          </div>
          <div class="popup-content">
            <van-field v-model="popupOption.code" />
          </div>
          <div class="popup-button">
            <van-button type="default" @click="getCode" v-if="!popupOption.isGeting">获取验证码</van-button>
            <van-button type="default" v-if="popupOption.isGeting">{{ popupOption.countdown }}s后重新获取</van-button>
            <van-button type="default" @click="receivingAddressRemoveBtn">{{ popupOption.confirmButtonText }}</van-button>
          </div>
        </van-popup>
      </div>

    </div>
  </template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import sortApi from '@/api/sort'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      addressList: [],
      selectAddress: {},
      popupOption: {
        popupShow: false,
        title: '请先获取验证码',
        confirmButtonText: '确定删除',
        code: '',
        isGeting: false,
        countdown: 60,
        address: null
      },
      couponId: null,
      addressSelected: [],
      itemId: '',
      addressId: ''
    }
  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有查看收货地址的权限')
    } else {
      this.init()
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  methods: {
    init () {
      this.itemId = this.$route.query.itemId ? this.$route.query.itemId : this.$route.params.itemId
      this.selectAddress = this.$route.query.selectAddress
      this.couponId = this.$route.params.selectCouponId || null
      this.getAddressList()
    },
    chooseValue (address) {
      this.addressId = address.addressId
    },
    // 收货地址
    getAddressList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      this.$store.dispatch('getAddress').then(response => {
        this.addressList = response
        this.addressList.forEach((add) => {
          if (add.isDefault === 1) {
            this.addressId = add.addressId
          }
        })
        this.$toast.clear()
      }).catch(() => { this.$toast.clear() })
    },

    //   提交
    grabAndGo () {
      // this.getAddressList()
      if (this.addressId === undefined || this.addressId === '') {
        this.$toast('请选择地址')
        return
      }
      this.$toast.loading({
        duration: 0,
        message: '提交中...',
        forbidClick: true
      })
      let data = {
        activityCode: 'SECKILL20230622',
        itemId: this.itemId,
        itemQuantity: '1',
        addressId: this.addressId
      }
      sortApi.getSubmitSpikeOrder(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$toast('抢购成功')
          setTimeout(() => {
            this.$router.push({
              name: 'home-main',
              params: {
                itemId: this.itemId
              }
            })
          }, 1000)
        } else {
          this.$toast.clear()
        }
      }).catch(() => { this.$toast.clear() })
    },

    // 添加地址
    receivingAddressAdd () {
      if (this.addressList && this.addressList.length >= 3) {
        this.$dialog.alert({
          message: '您添加地址次数已达到上限！'
        })
      } else {
        this.$router.replace({
          name: 'spikeAddressNew',
          params: {
            couponId: this.couponId,
            selectAddress: this.selectAddress,
            itemId: this.itemId
          }
        })
      }
    },
    // 编辑
    receivingAddressModify (address) {
      this.$router.replace({
        name: 'spikeAddressNew',
        params: {
          addressId: address.addressId,
          itemId: this.itemId,
          cityName: address.cityName,
          cityId: address.cityId,
          isDefault: address.isDefault,
          provinceName: address.provinceName,
          provinceId: address.provinceId,
          countyName: address.countyName,
          countyId: address.countyId,
          contactPerson: address.contactPerson,
          contactMobile: address.contactMobile,
          detailAddress: address.detailAddress,
          couponId: this.couponId,
          selectAddress: this.selectAddress
        }
      })
    },
    // 删除
    receivingAddressRemove (item) {
      this.popupOption.popupShow = true
      this.popupOption.address = item
    },
    selectNewAddress (addressId) {
      // selectAddress为0时表示是从创建订单页面过来修改收货地址 为1时表示时从秒杀页面过来修改收货地址
      if (this.selectAddress === 0) {
        this.$router.replace({
          name: 'spikeAddress',
          params: {
            newAddressId: addressId,
            selectCouponId: this.couponId,
            itemId: this.itemId
          }
        })
        return
      } else if (this.selectAddress === 1) {
        // $scope.selectNewAddress = function (addressId) {
        //   $state.go('seckillDetail', {
        //     newAddressId: addressId
        //   })
        // }
      }
      if (!addressId) {
        //   this.$router.go(-1)
        this.$router.replace({
          name: 'home-main',
          params: {
            itemId: this.itemId

          }
        })
      }
    },
    // 确定删除
    receivingAddressRemoveBtn () {
      if (this.popupOption.code === '') {
        this.$toast('验证码不能为空')
        return
      }
      const data = {
        addressId: this.popupOption.address.addressId,
        verifyCode: this.popupOption.code
      }
      activityApi.removeAddress(data).then(res => {
        if (res.data.resultCode === '0') {
          this.popupOption.popupShow = false
          this.addressId = ''
          this.$toast('删除成功')
          this.getAddressList()
        }
      })
    },
    // 获取验证码
    getCode () {
      if (!this.popupOption.isGeting) {
        let that = this
        activityApi.getAddressVerifyCode().then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('验证码已发送，请注意查收')
            this.popupOption.isGeting = true
            var timer = setInterval(function () {
              if (that.popupOption.countdown > 0) {
                that.popupOption.countdown--
              } else {
                clearInterval(timer)
                that.popupOption.isGeting = false
                that.popupOption.countdown = 60
              }
            }, 1000)
          }
        })
      }
    },
    closeModal () {
      this.popupOption.popupShow = false
      this.popupOption.code = ''
    },
    getBannerMobileImageUri (mobileImageUri) {
      return process.env.VUE_APP_EXTRA_SITE + mobileImageUri
    }
  }
}
</script>

  <style scoped lang="less">
  .receiving-address {
    .receiving-address-list {
      padding: 0.5rem;
      background-color: #fff;
      margin-bottom: 0.3rem;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
          margin: 0rem 0.3rem;
        }

        .text-green {
          color: var(--base-green);
        }
      }

      .margin-b-4 {
        width:300px ;
        word-break: break-word;
        margin-bottom: 0.4rem;
      }

    }

    .center-personal-data-submit {
      width: 80%;
      margin: 0.5rem auto 0 auto
    }

    .flex-end {
      justify-content: flex-end !important;
    }

    .popup {
      width: 80%;
      top: 50%;
      background-color: #f1f1f1;

      .popup-title {
        padding: 0.4rem;
      }

      .popup-content {
        background-color: #f1f1f1;
        padding: 0.2rem 0.4rem;
      }

      .closeIcon {
        position: absolute;
        right: 0px;
        top: 0px;
        padding: 0.2rem;
      }

      .popup-button {
        display: flex;

        button {
          flex: 1 1 50%;
          background-color: #f1f1f1;
          color: var(--base-green);
        }
      }
    }
  }
  </style>
